// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.token-history-page {
    background-color: transparent;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 2rem;
    position: relative;
    padding-top: 4rem;
}

/* Close Button */
.token-history-close-btn {
    position: fixed;
    top: 1.5rem;
    right: 1.5rem;
    z-index: 100;
    background: transparent;
    border: none;
    color: rgba(213, 190, 155, 1);
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.token-history-close-btn:hover {
    color: rgba(213, 190, 155, 1);
    transform: scale(1.1);
}

.token-history-close-btn svg {
    width: 24px;
    height: 24px;
}

/* Main Content */
.token-history-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 800px;
    gap: 2rem;
}

/* Title */
.token-history-title {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 2.5rem;
    font-weight: 400;
    color: rgba(213, 190, 155, 1);
    margin: 0;
    letter-spacing: 0.1em;
    text-align: center;
}

/* Tabs */
.token-history-tabs {
    display: flex;
    gap: 1rem;
    width: 100%;
}

.tab-btn {
    flex: 1 1;
    padding: 0.8rem 1.5rem;
    background-color: transparent;
    color: rgba(213, 190, 155, 1);
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 1rem;
    letter-spacing: 0.05em;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 400;
}

.tab-btn:hover {}

.tab-btn.active {
    background-color: rgba(213, 190, 155, 1);
    color: rgba(213, 190, 155, 1);
    border-color: rgba(213, 190, 155, 1);
}

/* Transaction List */
.transaction-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
}

.transaction-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 1rem 1.5rem;
    background-color: rgba(20, 20, 20, 0.8);
    border: 1px solid rgba(255, 217, 0, 0.3);
    border-radius: 8px;
    transition: all 0.3s ease;
}

.transaction-item:hover {
    border-color: rgba(213, 190, 155, 1);
    background-color: rgba(20, 20, 20, 0.9);
}

.transaction-left {
    display: flex;
    gap: 1rem;
    align-items: flex-start;
    flex: 1 1;
}

.transaction-tag {
    padding: 0.3rem 0.8rem;
    border-radius: 4px;
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 0.85rem;
    font-weight: 400;
    letter-spacing: 0.05em;
    white-space: nowrap;
    flex-shrink: 0;
}

.transaction-tag.consumption {
    background-color: rgba(220, 53, 69, 0.2);
    color: rgba(220, 53, 69, 1);
    border: 1px solid rgba(220, 53, 69, 0.5);
}

.transaction-tag.recharge {
    background-color: rgba(40, 167, 69, 0.2);
    color: rgba(40, 167, 69, 1);
    border: 1px solid rgba(40, 167, 69, 0.5);
}

.transaction-details {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    flex: 1 1;
}

.transaction-description {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 1rem;
    color: rgba(213, 190, 155, 1);
    margin: 0;
    letter-spacing: 0.05em;
}

.transaction-timestamp {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 0.85rem;
    color: rgba(213, 190, 155, 1);
    margin: 0;
    letter-spacing: 0.05em;
}

.transaction-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.3rem;
    flex-shrink: 0;
    margin-left: 1rem;
}

.transaction-amount {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 1.2rem;
    font-weight: 600;
    margin: 0;
    letter-spacing: 0.05em;
}

.transaction-amount.consumption {
    color: rgba(220, 53, 69, 1);
}

.transaction-amount.recharge {
    color: rgba(40, 167, 69, 1);
}

.transaction-balance {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 0.85rem;
    color: rgba(213, 190, 155, 1);
    margin: 0;
    letter-spacing: 0.05em;
}

/* Loading, Error, Empty States */
.loading-state,
.error-state,
.empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3rem;
    color: rgba(213, 190, 155, 0.7);
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 1rem;
    letter-spacing: 0.05em;
}

.error-state {
    color: rgba(220, 53, 69, 0.8);
}

/* Status Badge */
.transaction-status {
    display: inline-block;
    padding: 0.2rem 0.5rem;
    border-radius: 4px;
    font-size: 0.75rem;
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    margin-top: 0.3rem;
}

.transaction-status.status-success {
    background-color: rgba(40, 167, 69, 0.2);
    color: rgba(40, 167, 69, 1);
}

.transaction-status.status-failed {
    background-color: rgba(220, 53, 69, 0.2);
    color: rgba(220, 53, 69, 1);
}

.transaction-status.status-pending {
    background-color: rgba(255, 193, 7, 0.2);
    color: rgba(255, 193, 7, 1);
}

/* Responsive Design */
@media (max-width: 768px) {
    .token-history-page {
        padding: 1rem;
        padding-top: 3rem;
    }

    .token-history-close-btn {
        top: 1rem;
        right: 1rem;
    }

    .token-history-content {
        gap: 1.5rem;
    }

    .token-history-title {
        font-size: 2rem;
    }

    .token-history-tabs {
        gap: 0.8rem;
    }

    .tab-btn {
        padding: 0.7rem 1rem;
        font-size: 0.9rem;
    }

    .transaction-item {
        padding: 0.8rem 1rem;
        flex-direction: column;
        gap: 1rem;
    }

    .transaction-left {
        width: 100%;
    }

    .transaction-right {
        width: 100%;
        align-items: flex-start;
        margin-left: 0;
        padding-left: 3.5rem;
    }
}

@media (max-width: 480px) {
    .token-history-title {
        font-size: 1.5rem;
    }

    .tab-btn {
        font-size: 0.85rem;
        padding: 0.6rem 0.8rem;
    }

    .transaction-item {
        padding: 0.7rem 0.8rem;
    }

    .transaction-tag {
        font-size: 0.75rem;
        padding: 0.25rem 0.6rem;
    }

    .transaction-description {
        font-size: 0.9rem;
    }

    .transaction-timestamp {
        font-size: 0.8rem;
    }

    .transaction-amount {
        font-size: 1.1rem;
    }

    .transaction-balance {
        font-size: 0.8rem;
    }

    .transaction-right {
        padding-left: 3rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/userCenter/tokenHistory.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,SAAS;AACb;;AAEA,UAAU;AACV;IACI,4DAA4D;IAC5D,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,SAAS;IACT,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA,SAAS;AACT;IACI,aAAa;IACb,SAAS;IACT,WAAW;AACf;;AAEA;IACI,SAAO;IACP,sBAAsB;IACtB,6BAA6B;IAC7B,6BAA6B;IAC7B,4DAA4D;IAC5D,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA,gBAAgB;;AAEhB;IACI,wCAAwC;IACxC,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,oBAAoB;IACpB,uCAAuC;IACvC,wCAAwC;IACxC,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,SAAO;AACX;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,4DAA4D;IAC5D,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,wCAAwC;IACxC,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;IACxC,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,SAAO;AACX;;AAEA;IACI,4DAA4D;IAC5D,eAAe;IACf,6BAA6B;IAC7B,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,4DAA4D;IAC5D,kBAAkB;IAClB,6BAA6B;IAC7B,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;IACX,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,4DAA4D;IAC5D,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4DAA4D;IAC5D,kBAAkB;IAClB,6BAA6B;IAC7B,SAAS;IACT,sBAAsB;AAC1B;;AAEA,iCAAiC;AACjC;;;IAGI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,+BAA+B;IAC/B,4DAA4D;IAC5D,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;AACjC;;AAEA,iBAAiB;AACjB;IACI,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,4DAA4D;IAC5D,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,2BAA2B;AAC/B;;AAEA;IACI,wCAAwC;IACxC,2BAA2B;AAC/B;;AAEA;IACI,wCAAwC;IACxC,2BAA2B;AAC/B;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,SAAS;QACT,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;QACpB,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,uBAAuB;QACvB,cAAc;QACd,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".token-history-page {\r\n    background-color: transparent;\r\n    min-height: 100vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    padding: 2rem;\r\n    position: relative;\r\n    padding-top: 4rem;\r\n}\r\n\r\n/* Close Button */\r\n.token-history-close-btn {\r\n    position: fixed;\r\n    top: 1.5rem;\r\n    right: 1.5rem;\r\n    z-index: 100;\r\n    background: transparent;\r\n    border: none;\r\n    color: rgba(213, 190, 155, 1);\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    padding: 0.5rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.token-history-close-btn:hover {\r\n    color: rgba(213, 190, 155, 1);\r\n    transform: scale(1.1);\r\n}\r\n\r\n.token-history-close-btn svg {\r\n    width: 24px;\r\n    height: 24px;\r\n}\r\n\r\n/* Main Content */\r\n.token-history-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    max-width: 800px;\r\n    gap: 2rem;\r\n}\r\n\r\n/* Title */\r\n.token-history-title {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 2.5rem;\r\n    font-weight: 400;\r\n    color: rgba(213, 190, 155, 1);\r\n    margin: 0;\r\n    letter-spacing: 0.1em;\r\n    text-align: center;\r\n}\r\n\r\n/* Tabs */\r\n.token-history-tabs {\r\n    display: flex;\r\n    gap: 1rem;\r\n    width: 100%;\r\n}\r\n\r\n.tab-btn {\r\n    flex: 1;\r\n    padding: 0.8rem 1.5rem;\r\n    background-color: transparent;\r\n    color: rgba(213, 190, 155, 1);\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 1rem;\r\n    letter-spacing: 0.05em;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    font-weight: 400;\r\n}\r\n\r\n.tab-btn:hover {}\r\n\r\n.tab-btn.active {\r\n    background-color: rgba(213, 190, 155, 1);\r\n    color: rgba(213, 190, 155, 1);\r\n    border-color: rgba(213, 190, 155, 1);\r\n}\r\n\r\n/* Transaction List */\r\n.transaction-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    width: 100%;\r\n}\r\n\r\n.transaction-item {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n    padding: 1rem 1.5rem;\r\n    background-color: rgba(20, 20, 20, 0.8);\r\n    border: 1px solid rgba(255, 217, 0, 0.3);\r\n    border-radius: 8px;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.transaction-item:hover {\r\n    border-color: rgba(213, 190, 155, 1);\r\n    background-color: rgba(20, 20, 20, 0.9);\r\n}\r\n\r\n.transaction-left {\r\n    display: flex;\r\n    gap: 1rem;\r\n    align-items: flex-start;\r\n    flex: 1;\r\n}\r\n\r\n.transaction-tag {\r\n    padding: 0.3rem 0.8rem;\r\n    border-radius: 4px;\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 0.85rem;\r\n    font-weight: 400;\r\n    letter-spacing: 0.05em;\r\n    white-space: nowrap;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.transaction-tag.consumption {\r\n    background-color: rgba(220, 53, 69, 0.2);\r\n    color: rgba(220, 53, 69, 1);\r\n    border: 1px solid rgba(220, 53, 69, 0.5);\r\n}\r\n\r\n.transaction-tag.recharge {\r\n    background-color: rgba(40, 167, 69, 0.2);\r\n    color: rgba(40, 167, 69, 1);\r\n    border: 1px solid rgba(40, 167, 69, 0.5);\r\n}\r\n\r\n.transaction-details {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.3rem;\r\n    flex: 1;\r\n}\r\n\r\n.transaction-description {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 1rem;\r\n    color: rgba(213, 190, 155, 1);\r\n    margin: 0;\r\n    letter-spacing: 0.05em;\r\n}\r\n\r\n.transaction-timestamp {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 0.85rem;\r\n    color: rgba(213, 190, 155, 1);\r\n    margin: 0;\r\n    letter-spacing: 0.05em;\r\n}\r\n\r\n.transaction-right {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-end;\r\n    gap: 0.3rem;\r\n    flex-shrink: 0;\r\n    margin-left: 1rem;\r\n}\r\n\r\n.transaction-amount {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 1.2rem;\r\n    font-weight: 600;\r\n    margin: 0;\r\n    letter-spacing: 0.05em;\r\n}\r\n\r\n.transaction-amount.consumption {\r\n    color: rgba(220, 53, 69, 1);\r\n}\r\n\r\n.transaction-amount.recharge {\r\n    color: rgba(40, 167, 69, 1);\r\n}\r\n\r\n.transaction-balance {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 0.85rem;\r\n    color: rgba(213, 190, 155, 1);\r\n    margin: 0;\r\n    letter-spacing: 0.05em;\r\n}\r\n\r\n/* Loading, Error, Empty States */\r\n.loading-state,\r\n.error-state,\r\n.empty-state {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 3rem;\r\n    color: rgba(213, 190, 155, 0.7);\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 1rem;\r\n    letter-spacing: 0.05em;\r\n}\r\n\r\n.error-state {\r\n    color: rgba(220, 53, 69, 0.8);\r\n}\r\n\r\n/* Status Badge */\r\n.transaction-status {\r\n    display: inline-block;\r\n    padding: 0.2rem 0.5rem;\r\n    border-radius: 4px;\r\n    font-size: 0.75rem;\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    margin-top: 0.3rem;\r\n}\r\n\r\n.transaction-status.status-success {\r\n    background-color: rgba(40, 167, 69, 0.2);\r\n    color: rgba(40, 167, 69, 1);\r\n}\r\n\r\n.transaction-status.status-failed {\r\n    background-color: rgba(220, 53, 69, 0.2);\r\n    color: rgba(220, 53, 69, 1);\r\n}\r\n\r\n.transaction-status.status-pending {\r\n    background-color: rgba(255, 193, 7, 0.2);\r\n    color: rgba(255, 193, 7, 1);\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n    .token-history-page {\r\n        padding: 1rem;\r\n        padding-top: 3rem;\r\n    }\r\n\r\n    .token-history-close-btn {\r\n        top: 1rem;\r\n        right: 1rem;\r\n    }\r\n\r\n    .token-history-content {\r\n        gap: 1.5rem;\r\n    }\r\n\r\n    .token-history-title {\r\n        font-size: 2rem;\r\n    }\r\n\r\n    .token-history-tabs {\r\n        gap: 0.8rem;\r\n    }\r\n\r\n    .tab-btn {\r\n        padding: 0.7rem 1rem;\r\n        font-size: 0.9rem;\r\n    }\r\n\r\n    .transaction-item {\r\n        padding: 0.8rem 1rem;\r\n        flex-direction: column;\r\n        gap: 1rem;\r\n    }\r\n\r\n    .transaction-left {\r\n        width: 100%;\r\n    }\r\n\r\n    .transaction-right {\r\n        width: 100%;\r\n        align-items: flex-start;\r\n        margin-left: 0;\r\n        padding-left: 3.5rem;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .token-history-title {\r\n        font-size: 1.5rem;\r\n    }\r\n\r\n    .tab-btn {\r\n        font-size: 0.85rem;\r\n        padding: 0.6rem 0.8rem;\r\n    }\r\n\r\n    .transaction-item {\r\n        padding: 0.7rem 0.8rem;\r\n    }\r\n\r\n    .transaction-tag {\r\n        font-size: 0.75rem;\r\n        padding: 0.25rem 0.6rem;\r\n    }\r\n\r\n    .transaction-description {\r\n        font-size: 0.9rem;\r\n    }\r\n\r\n    .transaction-timestamp {\r\n        font-size: 0.8rem;\r\n    }\r\n\r\n    .transaction-amount {\r\n        font-size: 1.1rem;\r\n    }\r\n\r\n    .transaction-balance {\r\n        font-size: 0.8rem;\r\n    }\r\n\r\n    .transaction-right {\r\n        padding-left: 3rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
